//import region
import React from 'react';

// bootstrap
import Form from "react-bootstrap/Form";

// redux
import { useSelector, useDispatch } from "react-redux";
import { selectDepPaxNoShowsFilter, setDepPaxNoShows } from "_redux/slices/prm-bookings/calendar";

// styling
import { Colors} from "_styles";
//#end region
const DepPaxNoShowsToggle = (props) => {

    // redux
    const dispatch = useDispatch();

    // dep pax no shows filter
    const depPaxNoShowsFilter = useSelector(selectDepPaxNoShowsFilter);

    return (
        <div style={{ display: "flex" }}>
            <Form.Check onClick={(e) => { dispatch(setDepPaxNoShows(e.target.checked));}} type="switch" defaultChecked={depPaxNoShowsFilter} />
            <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Exclude Departure PAX No Shows</Form.Label>
        </div>
    );
};

export default DepPaxNoShowsToggle;
